var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left pa-6 logo"},[_vm._m(0),_c('div',{staticClass:"mt-2"},[_vm._v(" "+_vm._s(_vm.userName)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/image/admin_logo.png")}}),_c('span',{staticClass:"pl-1"},[_vm._v("TN-BOX")])])
}]

export { render, staticRenderFns }